import { HttpErrorResponse } from '@angular/common/http';
import { OperatorFunction } from 'rxjs';

import { SnackbarService } from '@fitscovery/ui/snackbar';
import { catchError } from 'rxjs/operators';

export abstract class PaymentsControlState {

  constructor(
    public snackbar: SnackbarService
  ) { }

  get catchResponse(): OperatorFunction<unknown, unknown> {
    return catchError((response: HttpErrorResponse) => {
      this.snackbar.openSnack({ message: response.error?.errors[0], duration: 5000 });
      throw new Error(response.error?.errors[0]);
    })
  }

}
